export default "__VITE_ASSET__Blvwz9pJ__"